import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Video from './components/Video';

class Alfred {
	constructor() {

		Promise.all([Alfred.domReady()]).then(() => this.init());
		Video.init();
	}

	init() {
		document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) =>
			document.addEventListener('DOMContentLoaded', resolve),
		);
	}
}

new Alfred();
